import { render, staticRenderFns } from "./PopupChatNotSupported.vue?vue&type=template&id=301ac2e6&scoped=true"
import script from "./PopupChatNotSupported.vue?vue&type=script&lang=js"
export * from "./PopupChatNotSupported.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301ac2e6",
  null
  
)

export default component.exports